module.exports = __webpack_public_path__ + "img/pr-2.168bd912.png";